/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_ActionInputs */

const en_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTION`)
};

const fr_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTION`)
};

const de_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTION`)
};

const it_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AZIONE`)
};

const ru_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕЙСТВИЕ`)
};

const es_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACCIÓN`)
};

const zh_cn2_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_ccsl_export_header_action = /** @type {(inputs: Ccsl_Export_Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AÇÃO`)
};

/**
* | output |
* | --- |
* | "ACTION" |
*
* @param {Ccsl_Export_Header_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_action = /** @type {((inputs?: Ccsl_Export_Header_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_action(inputs)
	if (locale === "de") return de_ccsl_export_header_action(inputs)
	if (locale === "it") return it_ccsl_export_header_action(inputs)
	if (locale === "ru") return ru_ccsl_export_header_action(inputs)
	if (locale === "es") return es_ccsl_export_header_action(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_action(inputs)
	if (locale === "ja") return ja_ccsl_export_header_action(inputs)
	if (locale === "hi") return hi_ccsl_export_header_action(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_action(inputs)
	return en_ccsl_export_header_action(inputs)
});